export function ShopSkeleton({lines = 3}: {lines?: number}) {
  return (
    <div className="shop-skeleton" aria-hidden="true">
      {Array.from({length: lines}, (_, i) => (
        <div key={i} className="shop-skeleton-line" style={{width: i === lines - 1 ? "60%" : "100%"}} />
      ))}
    </div>
  );
}

export function ProductGridSkeleton({count = 8}: {count?: number}) {
  return (
    <div className="shop-skeleton-grid cc-productGrid" aria-hidden="true">
      {Array.from({length: count}, (_, i) => (
        <div key={i} className="shop-skeleton-card">
          <div className="shop-skeleton-thumb" />
          <div className="shop-skeleton-line" />
          <div className="shop-skeleton-line short" />
        </div>
      ))}
    </div>
  );
}
